<mat-toolbar class="bg-beige-tricon flex justify-between">
    {{data.amenityName}}
    <button class="pl-4" mat-dialog-close>&times;</button>
</mat-toolbar>

<mat-dialog-content class="mt-2">
    <p>
        Good call! You've got your eye on our {{data.amenityName}} rental service, which is currently in the testing phase. 
        While this feature is not yet ready, we're working hard to make this feature available to you soon. 
        Your selection has been noted, and we appreciate your enthusiasm in helping us shape the future of our rental service. 
        Thanks for sharing your interest - you're a total rockstar!
    </p>
</mat-dialog-content>
<mat-dialog-actions class="flex mx-auto my-2 items-center justify-center">
    <button mat-flat-button class="flex items-center justify-center" color="primary" mat-dialog-close>CLOSE</button>
</mat-dialog-actions>